<template>
	<widget :height="height" :loading="loading">
		<vue-apex-charts class="mt-2" width="100%" :height="height" type="donut" :options="options" :series="series" />
	</widget>
</template>

<script>
import Widget from './Widget';
import VueApexCharts from 'vue-apexcharts';
import colors from '../../colors';

export default {
	components: {
		Widget,
		VueApexCharts
	},

	props: {
		id: { default: 'online-devices-chart' },
		height: { default: '160' },
		header: { default: null },
		onlineCount: {
			type: Number,
			default: null
		},
		offlineCount: {
			type: Number,
			default: null
		},
		syncingCount: {
			type: Number,
			default: null
		},
		unknownCount: {
			type: Number,
			default: null
		}
	},

	computed: {
		options () {
			return {
				chart: {
					id: this.id
				},
				labels: this.labels,
				colors: this.colors,
				title: {
					text: this.headerText,
					offsetX: 0,
					style: {
						fontSize: '18px',
						fontWeight: 'normal'
					}
				}
			};
		},

		headerText () {
			if (this.header === null) {
				return this.$t('widgets.device_online_status');
			}

			return this.header;
		},

		labels () {
			return [ 'Online', 'Offline', 'Syncing', 'Unknown' ];
		},

		colors () {
			return [ colors.bootstrap_success, colors.bootstrap_danger, colors.bootstrap_info, colors.dark_gray ];
		},

		series () {
			return [ this.onlineCount, this.offlineCount, this.syncingCount, this.unknownCount ];
		},

		loading () {
			return this.onlineCount === null || this.offlineCount === null;
		}
	}
};
</script>
